module.exports = __webpack_public_path__ + "img/37.92251816.jpg";